﻿import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { ToastProvider } from '@/components/common/Toast';
import Layout from '@/components/layout/Layout';
import Spinner from '@/components/common/Spinner';
import LoginPage from '@/pages/LoginPage';
import ExpiredPasswordPage from '@/pages/ExpiredPasswordPage';
import VisitListPage from '@/pages/VisitListPage';
import NewVisitPage from '@/pages/NewVisitPage';
import ProspectListPage from '@/pages/ProspectListPage';
import ToolsPage from '@/pages/ToolsPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Suspense fallback={<Spinner text="Caricamento..." />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/password-scaduta" element={<ExpiredPasswordPage />} />
              <Route element={<Layout />}>
                <Route path="/visite" element={<VisitListPage />} />
                <Route path="/visite/nuova" element={<NewVisitPage />} />
                <Route path="/prospect" element={<ProspectListPage />} />
                <Route path="/tools" element={<ToolsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Suspense>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
